var React = require('react');

function CheckAnimated (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"className":"tick path","strokeDasharray":"50","strokeDashoffset":"50","style":{"fill":"none","stroke":"#FFF","strokeWidth":"2","strokeLinejoin":"round","strokeMiterlimit":"10"},"points":"\n  11.6,20 15.9,24.2 26.4,13.8 "},React.createElement("animate",{"attributeName":"stroke-dashoffset","dur":"0.5s","stroke":"#FFF","fill":"freeze","from":"50","to":"0"})));
}

CheckAnimated.defaultProps = {"className":"animated-logo","version":"1.1","id":"tick","viewBox":"5 7 25 25","height":"100%","width":"100%"};

module.exports = CheckAnimated;

CheckAnimated.default = CheckAnimated;
